const TABS_VARIANTS = {
    UNDERLINE: 'underline',
    FILLED: 'filled',
};

const TABS_THEMES = {
    GREEN: 'green',
    MONOCHROME: 'monochrome',
};

export {
    TABS_VARIANTS,
    TABS_THEMES,
};
